import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { URLSearchParamsInit } from "react-router-dom";
import {
  IEnquiryResponseSchema,
  IPrefillEnquiryResponseSchema,
} from "./enquiry.types";

const getEnquiryApi = ({
  searchParams,
  signal,
}: {
  searchParams?: URLSearchParamsInit;
  signal?: AbortSignal;
}): Promise<{
  data: IEnquiryResponseSchema;
  prefilled_enquiry_id: number | null;
  prefilled_data: IPrefillEnquiryResponseSchema | null;
}> => handleGlobalGetRequestQuery({ url: URLS.ENQUIRY, searchParams, signal });

export { getEnquiryApi };
